import type { AnnotatedGraph } from '@litlingo/react';
import RawEmail from 'components/HighlightedSentenceComponent/RawEmail';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getSelectedSentence } from 'selectors/envelopeReview';
import type { UUID } from 'types';
import WrapperHighlightedSentence from './WrapperHighlightedSentence';

type ComponentProps = {
  eventId: UUID;
  commUuid: UUID | null;
  fullMessageOptions: string;
  onlySubject?: boolean;
  borderSeparation?: string;
  highRiskOnly?: boolean;
  hideHighlight?: boolean;
  underlineOnly?: boolean;
  handleSentenceClick?: (line: AnnotatedGraph, nodes: number[]) => void;
};

const HighlightedSentenceComponent: React.FC<ComponentProps> = ({
  eventId,
  commUuid,
  fullMessageOptions,
  onlySubject,
  borderSeparation,
  highRiskOnly = false,
  hideHighlight = false,
  underlineOnly = false,
  handleSentenceClick,
}) => {
  const FULL_OPTIONS = {
    HIGHLIGHTED: 'HIGHLIGHTED',
    PLAIN: 'PLAIN',
  };

  const selectedSentence = useSelector(getSelectedSentence);

  useEffect(() => {
    const element = document.querySelector(
      `div[data-communication-id="${selectedSentence.communicationId}"][data-index="${selectedSentence.index}"]`
    );

    if (element) {
      element.scrollIntoView();
    }
  }, [selectedSentence]);

  const renderContent = (): JSX.Element | null => {
    if (fullMessageOptions === FULL_OPTIONS.HIGHLIGHTED) {
      return (
        <WrapperHighlightedSentence
          eventId={eventId}
          commUuid={commUuid}
          onlySubject={onlySubject || false}
          borderSeparation={borderSeparation}
          highRiskOnly={highRiskOnly}
          hideHighlight={hideHighlight}
          underlineOnly={underlineOnly}
          handleSentenceClick={handleSentenceClick}
        />
      );
    }
    if (fullMessageOptions === FULL_OPTIONS.PLAIN) {
      return <RawEmail eventId={eventId} commUuid={commUuid} />;
    }
    return null;
  };

  return <>{renderContent()}</>;
};

export default HighlightedSentenceComponent;
